var _rect, _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStripe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 296,
    height: 93,
    viewBox: "0 0 296 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_618_131",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 296,
    height: 93
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 296,
    height: 93,
    rx: 5,
    fill: "url(#paint0_linear_618_131)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_618_131)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M500.979 228.29L500.993 228.255L501.002 228.219C512.07 183.044 513.87 138.711 501.5 105.641C495.312 89.0967 485.572 75.3599 471.664 65.7622C457.756 56.1646 439.716 50.7314 416.972 50.7314C371.586 50.7314 324.933 59.0774 282.481 82.508C240.024 105.942 201.801 144.447 173.256 204.71L173.248 204.728L173.24 204.747C146.446 275.931 139.461 331.762 150.598 369.836C156.171 388.888 166.285 403.502 180.725 413.347C195.16 423.189 213.877 428.237 236.613 428.237C282.076 428.237 336.113 407.547 384.793 372.235C433.479 336.918 476.858 286.938 500.979 228.29Z",
    stroke: "#1A2CCE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M480.339 190.07L480.353 190.035L480.362 189.998C491.43 144.824 493.23 100.491 480.86 67.4213C474.671 50.8766 464.931 37.1398 451.023 27.5421C437.115 17.9445 419.076 12.5114 396.331 12.5114C350.945 12.5114 304.292 20.8573 261.841 44.2879C219.383 67.7216 181.161 106.227 152.616 166.489L152.607 166.508L152.6 166.527C125.805 237.711 118.821 293.542 129.958 331.616C135.531 350.668 145.644 365.282 160.085 375.127C174.52 384.969 193.237 390.017 215.972 390.017C261.436 390.017 315.472 369.327 364.152 334.015C412.839 298.698 456.217 248.718 480.339 190.07Z",
    stroke: "#1A2CCE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M548.157 240.487L548.172 240.452L548.181 240.416C559.249 195.241 561.049 150.909 548.679 117.839C542.49 101.294 532.75 87.5573 518.842 77.9596C504.934 68.362 486.894 62.9288 464.15 62.9288C418.764 62.9288 372.111 71.2748 329.66 94.7053C287.202 118.139 248.979 156.644 220.435 216.907L220.426 216.926L220.419 216.945C193.624 288.128 186.639 343.959 197.776 382.033C203.349 401.086 213.463 415.7 227.903 425.545C242.339 435.386 261.055 440.434 283.791 440.434C329.254 440.434 383.291 419.745 431.971 384.432C480.658 349.115 524.036 299.136 548.157 240.487Z",
    stroke: "#1A2CCE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M427.263 174.618L427.277 174.583L427.286 174.547C438.354 129.372 440.154 85.0398 427.784 51.9698C421.596 35.425 411.856 21.6883 397.947 12.0906C384.039 2.49294 366 -2.94019 343.255 -2.94019C297.87 -2.94019 251.217 5.40578 208.765 28.8363C166.308 52.2701 128.085 90.7751 99.5401 151.038L99.5312 151.057L99.524 151.076C72.7293 222.259 65.7449 278.09 76.8818 316.164C82.4548 335.217 92.5687 349.831 107.009 359.676C121.444 369.517 140.161 374.565 162.896 374.565C208.36 374.565 262.396 353.876 311.076 318.563C359.763 283.246 403.141 233.267 427.263 174.618Z",
    stroke: "#1A2CCE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.727 155.783L381.731 155.772L381.734 155.761C392.794 110.617 394.578 66.3651 382.244 33.3903C376.076 16.8999 366.375 3.22649 352.536 -6.32349C338.697 -15.8735 320.731 -21.2923 298.043 -21.2923C252.699 -21.2923 206.108 -12.9539 163.722 10.4406C121.334 33.8361 83.16 72.2837 54.644 132.486L54.6435 132.485L54.6392 132.497C27.8522 203.66 20.901 259.401 32.0053 297.364C37.5589 316.35 47.6295 330.891 61.9937 340.684C76.3563 350.477 94.9991 355.513 117.684 355.513C163.052 355.513 217.018 334.862 265.658 299.578C314.301 264.292 357.634 214.362 381.727 155.783Z",
    stroke: "#1A2CCE",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M395.146 140.408C366.282 205.668 314.369 261.317 256.073 300.654C197.762 340.002 133.114 362.995 78.8319 362.995C51.6933 362.995 29.4532 357.39 12.3511 346.544C-4.74373 335.703 -16.7417 319.601 -23.366 298.535C-36.6241 256.372 -28.3543 194.316 3.77744 114.903C72.0989 -19.2527 186.645 -56.4222 295.333 -56.4222C322.463 -56.4222 343.894 -50.3952 360.373 -39.8164C376.851 -29.239 388.413 -14.0892 395.774 4.21579C410.5 40.8375 408.398 90.0717 395.146 140.408Z",
    stroke: "#1A2CCE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_618_131",
    x1: 148,
    y1: 0,
    x2: 148,
    y2: 93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000A62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000A62"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStripe);
export default __webpack_public_path__ + "static/media/stripe.bcf35e0be95ab4e3a083ae76466e4406.svg";
export { ForwardRef as ReactComponent };